import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

export interface InformationModalOptions {
  message?: string;
  iconName?: string;
  iconColor?: string;
  iconSize?: string;
  buttonText?: string;
  buttonColor?: string;
}

@Component({
  selector: "app-information",
  templateUrl: "./information.component.html",
  styleUrls: ["./information.component.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class InformationComponent {
  @Input() message: string = "MODAL.DEFAULTMESSAGE.INFO";
  @Input() iconName: string = "information-circle-outline";
  @Input() iconColor: string = "primary";
  @Input() iconSize: string = "4.5em";
  @Input() buttonText: string = "BTN.OK";
  @Input() buttonColor: string = "dark";

  modalState: ModalStateService;

  constructor() {
    this.modalState = inject(ModalStateService);
  }

  close() {
    this.modalState.triggerDismiss("information", true);
  }
}
